import React from 'react';
import * as constants from '../../constants/ticketStatuses';
import MessagesComponent from 'components/Messages/Messages';
import {
  trackTicketReassigned,
  trackTagPickerOpenedOnTake,
  TICKET_ACTION_SOURCES,
} from '../../analytics/ticketEventAnalytics';
import { trackButtonClick, BUTTONS } from '../../analytics/buttonEventAnalytics';
import * as SessionAnalyticsService from 'services/SessionAnalyticsService/SessionAnalyticsService';
import TicketButton from '../Buttons/TicketButton/TicketButton';
import { BUTTON_IDS } from '../../reducers/ui/buttons';
import InboxButtonContainer from '../../containers/tools/InboxButtonContainer';
import { twoBtnPopupCreator } from '../popups/ConfirmPopup/helper';
import { InboxButtonWrapper, FlexRowReverse, NoButtonPlaceholder } from '../common/buttonsComponents';
import SelectedMessage from '../Messages/SelectedMessage/SelectedMessage';
import { getAccountBrandConfigValue } from '../../util';
import { ErrorStrings } from '../../constants/fixedMessages';
import { showErrorMessage } from '../../util/errorPopupUtil';
import { AllTicketBox, ButtonHolder } from './AllTicketComponent.styles';
import { SHOW_EMAIL_TO_EXPERTS, IS_SHOW_EMAIL_TO_EXPERTS } from 'constants/extraBusinessInfo';

class AllTicketComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      disableAllButtons: false,
    };
  }

  UNSAFE_componentWillMount() {
    this.props.clearHistoricalTicket();
    this.props.setChatMacroRecommendationsEnabled(true);
  }

  handleEscalateClick() {
    const { ticket } = this.props.selectedTicket || {};
    this.props.handleEscalationPopup(ticket);
  }

  onClickTake(buttonId) {
    const {
      onTakeClick,
      onRessaignTicket,
      selectedTicket: { ticket },
    } = this.props;

    if (!ticket) {
      showErrorMessage(new Error(ErrorStrings.SELECTED_TICKET_NOT_FOUND), true);

      return;
    }

    if (ticket.ticketStatus && ticket.ticketStatus === constants.TICKET_STATUS_ASSIGNED) {
      twoBtnPopupCreator({
        content: {
          main: 'This ticket is already assigned to another Simplr agent.',
          iconPath: '/images/green-alert-bell.svg',
          subText: ['Are you sure you want to take this conversation? It will remove it from their queue.'],
        },
        btnConfig: {
          dismiss: 'NO, DO NOT TAKE',
          confirm: 'YES, TAKE ANYWAY',
        },
        onConfirm: () => {
          onRessaignTicket(ticket.ticketId, buttonId);
          trackTicketReassigned(ticket.expertId);
        },
      });
    } else if (this.props.simplrTaggingRequired) {
      trackTagPickerOpenedOnTake(TICKET_ACTION_SOURCES.ALL_TICKET_COMPONENT);
      this.props.setTaggingActive(true);
      this.props.setShowTools(true);
    } else {
      onTakeClick(ticket.ticketId, buttonId);
    }
  }

  shouldShowButtons() {
    return this.props.selectedInboxTab === 'all';
  }

  render() {
    const {
      selectedTicket: { ticket },
      btnActivity,
      setBtnActivity,
      showTools,
      setShowTools,
      businessDetailsForTicket,
      hasExpertSelectedInForwarding,
      simplrTaggingActive,
      selectedConversation,
    } = this.props;

    // if no ticket is selected, render nothing
    if (!ticket || !ticket.simplrAccountPtrId) {
      return null;
    }

    let showTake = '';
    let showActions = '';

    if (ticket.ticketStatus) {
      switch (ticket.ticketStatus) {
        case constants.TICKET_STATUS_NOMINATED:
        case constants.TICKET_STATUS_AWAITING_NOMINATION:
        case constants.TICKET_STATUS_NOMINATED_FROM_ESCALATED:
        case constants.TICKET_STATUS_ESCALATED:
          showTake = '';
          break;
        case constants.TICKET_STATUS_AWAITING_SPECIALIST:
          showTake = '';
          break;
        case constants.TICKET_STATUS_HIDDEN:
          showTake = 'hide';
          break;
        case constants.TICKET_STATUS_ASSIGNED:
          showTake = '';
          break;
        case constants.TICKET_STATUS_SELF_HELP:
          showTake = '';
          break;
        default:
          showTake = 'hide';
        /* eslint-disable no-duplicate-case */
      }
    }
    if (this.props.isHistoricalTicket) {
      showTake = 'hide';
      showActions = 'hide';
    }

    const { allTakeBtn } = BUTTON_IDS;

    // TODO: create a component which take showButton and disableButton as props
    // all buttons except Unhide should be disabled by simplrTaggingActive
    // goal is to disable buttons when TagPicker is open so other actions on a ticket can't be taken during tagging
    const setButtonClasses = (showButton, disableButton) => {
      const classNameArray = [];
      if (showButton) {
        classNameArray.push(showButton);
      }
      if (disableButton) {
        classNameArray.push('btn-simplr-disabled');
      }

      return classNameArray.join(' ');
    };

    const showEmailToExperts = getAccountBrandConfigValue(
      businessDetailsForTicket,
      SHOW_EMAIL_TO_EXPERTS,
      ticket.brand,
      IS_SHOW_EMAIL_TO_EXPERTS
    );

    return (
      <AllTicketBox className={'full-height'}>
        <>
          {this.shouldShowButtons() ? (
            <ButtonHolder>
              {showTools && (
                <InboxButtonWrapper>
                  <InboxButtonContainer />
                </InboxButtonWrapper>
              )}
              {!hasExpertSelectedInForwarding && (
                <FlexRowReverse>
                  <TicketButton
                    label="TAKE"
                    buttonId={allTakeBtn}
                    fullColored={true}
                    active={btnActivity.allTakeBtn && !simplrTaggingActive}
                    disabled={simplrTaggingActive}
                    className={setButtonClasses(showTake, simplrTaggingActive)}
                    clickAction={(buttonId) => this.onClickTake(buttonId)}
                    setBtnActivity={!simplrTaggingActive && setBtnActivity}
                  />
                  {!showTools && showActions === '' && (
                    <TicketButton
                      label="ACTIONS"
                      className={setButtonClasses(null, simplrTaggingActive)}
                      active={!simplrTaggingActive}
                      disabled={simplrTaggingActive}
                      onClick={() => {
                        this.props.setTaggingActive(false);
                        setShowTools(!showTools);
                        trackButtonClick(BUTTONS.ACTIONS);
                        SessionAnalyticsService.event('Expert Clicked Actions');
                      }}
                    />
                  )}
                </FlexRowReverse>
              )}
            </ButtonHolder>
          ) : (
            <NoButtonPlaceholder />
          )}
        </>
        <SelectedMessage
          isAdmin={true}
          ticket={ticket}
          showEmailToExperts={showEmailToExperts}
          checked={this.hasTicketBeenChecked}
          onCheck={(e) => this.handleTicketCheckboxClick(e)}
          conversation={selectedConversation}
          isHistoricalTicket={this.props.isHistoricalTicket}
        />
        <MessagesComponent />
      </AllTicketBox>
    );
  }
}

export default AllTicketComponent;
